const uuidv4 = require(`uuid/v4`);

const get_uuid = function () {
    return uuidv4();
};

module.exports = get_uuid;